import type { FC } from 'react';

import { getCountdownContainerStyles, getCountdownTextStyles } from './styled';
import type { CountdownTimerProps } from './types';

const CountdownTimer: FC<CountdownTimerProps> = ({ seconds, isExpired }) => {
	const formatTime = (totalSeconds: number): string => {
		const minutes = Math.floor(totalSeconds / 60);
		const secs = totalSeconds % 60;
		return `${minutes}:${secs.toString().padStart(2, '0')}`;
	};

	const isUrgent = seconds <= 60 && seconds > 0;

	if (isExpired) {
		return (
			<div
				style={getCountdownContainerStyles(true)}
				role='alert'
				aria-live='assertive'
			>
				<i
					className='fas fa-exclamation-circle'
					aria-hidden='true'
				/>
				<span style={getCountdownTextStyles(true)}>Verification code has expired</span>
			</div>
		);
	}

	return (
		<div
			style={getCountdownContainerStyles(isUrgent)}
			aria-live='polite'
		>
			<i
				className='fas fa-clock'
				aria-hidden='true'
			/>
			<span style={getCountdownTextStyles(isUrgent)}>Code expires in {formatTime(seconds)}</span>
		</div>
	);
};

export default CountdownTimer;
